export enum DialogSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}
